import { Module } from 'vuex';
import { NodeOsAccountState } from './types';
import { RootState } from '../../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: NodeOsAccountState = {
    osAccounts: undefined,
    osAccountCount: 0,
    osAccountDetails: {
        account: undefined,
        node: undefined,
    },
    wkOsAccounts: undefined,
    wkOsAccountCount: 0,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    directSearch: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    create: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    update: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    connection: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const nodeOsAccount: Module<NodeOsAccountState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
